// ════════════════════════════════════════════════════════════════════
// Glass-i — Internal Breakage → Rework Request · pure frontend helpers.
// No React, no network — unit-testable in isolation (mirrors the project's
// proformaApprovalHelpers / workOrderHelpers convention).
//
// The reason list is a FIXED, hardcoded set (there is no reasons endpoint).
// It mirrors the backend breakage reason enum exactly.
// ════════════════════════════════════════════════════════════════════

// Wildcard-aware permission check (mirrors workOrderHelpers.hasPermission).
export function hasPermission(permissions, key) {
  if (!Array.isArray(permissions)) return false;
  return permissions.includes('*') || permissions.includes(key);
}

export const PERM = Object.freeze({
  REQUEST: 'erp.production.workorder.breakage.request',
  APPROVE: 'erp.production.workorder.breakage.approve',
  // The remake-sticker reprint reuses the work-order piece-sticker endpoint,
  // which is gated on the piece-PRINT permission (not a breakage permission).
  PRINT:   'erp.production.workorder.piece.print'
});

// FIXED breakage reason list — hardcoded (no reasons endpoint on the backend).
export const BREAKAGE_REASONS = Object.freeze([
  { code: 'HANDLING',           label: 'Handling damage' },
  { code: 'MACHINE',            label: 'Machine fault' },
  { code: 'THERMAL',            label: 'Thermal breakage' },
  { code: 'CUTTING_DEFECT',     label: 'Cutting defect' },
  { code: 'EDGE_CHIP',          label: 'Edge chip / spall' },
  { code: 'INTERNAL_TRANSPORT', label: 'Internal transport' },
  { code: 'OTHER',              label: 'Other' }
]);

const REASON_LABEL = BREAKAGE_REASONS.reduce((acc, r) => { acc[r.code] = r.label; return acc; }, {});

export function reasonLabel(code) {
  if (!code) return '—';
  return REASON_LABEL[code] || String(code);
}

const STATUS_LABEL = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled'
};
export function statusLabel(s) {
  if (!s) return '—';
  return STATUS_LABEL[s] || String(s);
}

// AntD Tag colours by request status.
const STATUS_COLOR = {
  PENDING: 'blue',
  APPROVED: 'green',
  REJECTED: 'red',
  CANCELLED: 'default'
};
export function statusColor(s) {
  return STATUS_COLOR[s] || 'default';
}

// Status tabs for the approvals page. `status` is the server filter value.
export const BREAKAGE_STATUS_TABS = Object.freeze([
  { key: 'pending',  label: 'Pending',  status: 'PENDING' },
  { key: 'approved', label: 'Approved', status: 'APPROVED' },
  { key: 'rejected', label: 'Rejected', status: 'REJECTED' }
]);

export function statusForTab(tabKey) {
  const tab = BREAKAGE_STATUS_TABS.find((t) => t.key === tabKey);
  return tab ? tab.status : 'PENDING';
}
